enum QueryParamKey {
  SOCIAL_MEDIA_TEMPLATE_ID = "smtId",
  TOKEN = "token",
  FIELD_TYPE = "fieldtypes",
  FILTER = "filter",
  ID = "id",
  CONSOLE_USER_ID = "cuId",
  CONSOLE_USER_ROLE_ID = "cuRId",
  MODAL = "md",
  COMMUNITY_SPONSOR = "cs",
  PREVIEW_MODE = "prv",
  FORM_ID = "fId",
  REG_PARTICIPATION_ID = "pId",
  COUPON_CODE = "cId",
  SPONSOR_ORG_ID = "spId",
  DIVISION_ID = "dvId",
  KEY = "key",
  TAB = "tab",
  PROGRAM_TYPE = "pType",
  TIME_SESSION_ID = "tsid",
  PROGRAM_ID = "pid",
  AGENDA_ATTRIBUTE_ID = "aaid",
  PROFILE_FORM_TYPE = "prft",
  EMAIL_ID = "emailId",
  STEP_NUMBER = "stepNo",
  WITH_STATUS = "withStatus",
  PARENT_KEY = "pKey",
  PARENT_FILTER = "pFilter",
  INVOICE_PAYMENT_REQUEST_ID = "iprId",
  INVOICE_PAYER_ID = "ipId",

  COOKIES = "cookies",
  USER_NAME = "usrName",
  PASSWORD = "pwd",
  NAME = "name",
  REGISTRATION_FORM_TYPE = "rft",
  VIEW_TYPE = "viewType",
  REQUEST_PENDING = "reqPending",
  INVENTORY_TYPE = "invType",
  INVENTORY_ID = "invId",
  IS_EXTERNAL_INV_PURCHASE = "extInv"
}

export default QueryParamKey;
